import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { Btn } from "../UI";
import { FInput, FLabel } from "../../pages/engagement/FormControls";
import { Store } from "lucide-react";

const FIELDS = [["name", "Pharmacy name *", "col-span-2"], ["phone", "Phone", ""], ["fax", "Fax", ""], ["address", "Street address", "col-span-2"],
  ["city", "City", ""], ["state", "State", ""], ["zip", "ZIP", ""], ["email", "Email (for sending prescriptions)", ""]];

/** Add a pharmacy to the Pharmacy Directory without leaving the current form. */
export function PharmacyQuickAdd({ onAdded, onCancel, testId = "pharmacy-quick-add" }) {
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const r = await api.post("/pharmacy-directory", f); toast.success(`${r.data.name} added to the Pharmacy Directory`); onAdded(r.data); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-2 space-y-3 rounded-xl border border-[#E5DFD3] bg-[#FDFCF8] p-3" data-testid={testId}>
      <div className="flex items-center gap-1.5 text-xs font-bold text-[#3E2723]"><Store size={13} /> New pharmacy</div>
      <div className="grid grid-cols-2 gap-2">
        {FIELDS.map(([k, label, span]) => (
          <div key={k} className={span}><FLabel>{label}</FLabel>
            <FInput data-testid={`${testId}-${k}`} value={f[k] || ""} onChange={(e) => setF((s) => ({ ...s, [k]: e.target.value }))} /></div>
        ))}
      </div>
      <div className="flex justify-end gap-2">
        <Btn variant="ghost" type="button" onClick={onCancel}>Cancel</Btn>
        <Btn type="button" data-testid={`${testId}-save`} disabled={busy || !(f.name || "").trim()} onClick={save}>Add pharmacy</Btn>
      </div>
    </div>
  );
}
